import React from "react";
import Meta from "../../components/Meta";
import HomeHero from "./HomeHero";
import HomeFeaturedCategories from "./HomeFeaturedCategories";
import HomeNewArrivals from "./HomeNewArrivals";
import HomeArchiveStory from "./HomeArchiveStory";
import HomeWhyAcademy from "./HomeWhyAcademy";
import HomeNewsletter from "./HomeNewsletter";

import "./HomeScreen.css";

const HERO_IMAGE = "/images/home/hero.jpg";

export default function HomeScreen() {
  return (
    <main className="home-screen">
      <Meta
        title="Academy Costumes London | Film, TV & Theatre Costume Specialists"
        description="Academy Costumes London provides costume production, bespoke tailoring, vintage textiles, haberdashery and specialist costume services for film, television, theatre, fashion, music and commercials in London."
        image={HERO_IMAGE}
        url="/"
      />
     
      {/* 1. Full-bleed hero — brand intro + CTA to /shop */}
      <HomeHero heroImage={HERO_IMAGE} />

      {/* 2. Compact shop teaser strip — 3 links, not a duplicate of /shop */}
      <HomeFeaturedCategories />

      {/* 3. New arrivals product grid */}
      <HomeNewArrivals />

      {/* 4. Editorial archive story section */}
      <HomeArchiveStory />

      {/* 5. Why Academy Costumes London — differentiators */}
      <HomeWhyAcademy />

      {/* 6. Newsletter signup */}
      <HomeNewsletter />
    </main>
  );
}
